module.exports = __webpack_public_path__ + "static/media/img-ceo@3x.183169ff.png";